import { Component, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ApplicationPipesModule } from '../../../pipes/application-pipes.module';
import { CommonModule } from '@angular/common';
import { DxToolbarModule, DxDataGridModule, DxPopupModule, DxButtonModule } from 'devextreme-angular';
import { AuthService, ScreenService, ConfigurationService, IdentityService, SignalrService, NotificationService } from '../../../services';
import { StorageService } from '../../../services/storage.service';
import { ToastrService } from 'ngx-toastr';
import { ViewChild } from '@angular/core';
import { DxDataGridComponent, DxToastModule } from 'devextreme-angular';
import { ShareholderType } from '../../../models/assemblea/ShareholderType';
import { AssembleaService } from '../../../services/assemblea.service';
import { MatDialog } from '@angular/material/dialog';
import { isNullOrWhiteSpace, isNullOrUndefined } from '../../../utils/utils';
import * as _ from 'lodash';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { vShareholders } from '../../../models/assemblea/vShareholders';
import { HttpParams, HttpClient } from '@angular/common/http';
import { ErrorService } from '../../../services/error.service';
import { Agency } from '../../../models/assemblea/Agency';
import { VipNoteStyle } from '../../../models/assemblea/VipNoteStyle';
import CustomStore from 'devextreme/data/custom_store';

@Component({
  selector: 'app-shareholder-config',
  templateUrl: './shareholder-config.component.html',
  styleUrls: ['./shareholder-config.component.scss']
})
/** shareholder-config component*/
export class ShareholderConfigComponent {
  shareholderTypesArray: ShareholderType[];
  agencyArray: Agency[];
  vipStyleArray: VipNoteStyle[];
  LegalRepresentatives: any;
  RepresentedShareholder: any;
  phonePattern = "^[0-9]{0,12}$";
  countryPattern = "^[0-9]{2}$";
  languagePattern = "^[a-z]{2}-[A-Z]{2}$";
  emailPattern = "^[a-z0-9_\\+-]+(\\.[a-z0-9_\\+-]+)*@[a-z0-9-]+(\\.[a-z0-9-]+)*\\.([a-z]{2,4})$";

  InError: boolean = false;
  ScrollToNew: boolean = false;
  confirmDeleteMessage: string = "Sicuro di voler procedere con la cancellazione del partecipante?";

  @ViewChild(DxDataGridComponent) grid: DxDataGridComponent;

  dataSource: CustomStore;

  windowSize = window;

  constructor(private assembleaService: AssembleaService, private errorService: ErrorService
    , private dialog: MatDialog, private configurationService: ConfigurationService
    , private ngxService: NgxUiLoaderService, private toastr: ToastrService, httpClient: HttpClient
  ) {

    this.closeCategoryClick = this.closeCategoryClick.bind(this);
    this.closeLRPopupClick = this.closeLRPopupClick.bind(this);

    this.ngxService.start();
    const that = this;
    var apiUrl = `${this.configurationService.serverSettings.webApiServiceUrl}/`

    function isNotEmpty(value: any): boolean {
      return value !== undefined && value !== null && value !== "";
    }

    this.initObject().then(() => {

      this.dataSource = new CustomStore({
        key: "PAID",
        load: (loadOptions) => {
          return new Promise((resolve, reject) => {
            let params: HttpParams = new HttpParams();
            [
              "skip",
              "take",
              "requireTotalCount",
              "requireGroupCount",
              "sort",
              "filter",
              "totalSummary",
              "group",
              "groupSummary"
            ].forEach(function (i) {
              if (i in loadOptions && isNotEmpty(loadOptions[i]))
                params = params.set(i, JSON.stringify(loadOptions[i]));
            });
            return httpClient.get(apiUrl + 'GetvShareholdersPaging', { params: params })
              .toPromise()
              .then((data: any) => {
                resolve(data);
                //return {
                //  data: data.data,
                //  totalCount: data.totalCount,
                //  summary: data.summary,
                //  groupCount: data.groupCount
                //};
                //this.ngxService.stop();
              })
              .catch(e => {
                errorService.showErrorMessage(e)
                this.ngxService.stop();
              });

          });
        },
        //onLoaded: (result) => {
        //  this.ngxService.stop();
        //},
        insert: ((values) => {
          this.ngxService.start();
          return this.assembleaService.insertOrUpdatevShareholders(values)
            .then((values) => {
            //this.grid.instance.refresh().then(() => {
            //  this.grid.instance.navigateToRow(values.PAID);
            //  //this.ngxService.stop();
            //});
            return values;
          }).catch((e) => {
            errorService.showErrorMessage(e);
            this.ngxService.stop();
          });
        }),
        onInserted: (values, key) => {
          this.grid.instance.refresh().then(() => {
            this.grid.instance.navigateToRow(key);
            this.ngxService.stop();
          });
        },
        remove: (key) => {
          this.ngxService.start();
          return this.assembleaService.deletevShareholders(new vShareholders({ PAID: key }))
            .catch((e) => {
              errorService.showErrorMessage(e);
              this.ngxService.stop();
            });
        },
        onRemoved: (key) => {
          this.loadLegalRepresentatives()
            .finally(() => {
              this.ngxService.stop();
            })
        },

        update: (key, values) => {
          this.ngxService.start();
          return this.assembleaService.insertOrUpdatevShareholders(values)
            .then((values) => { return values; })
            .catch((e) => {
              errorService.showErrorMessage(e);
              this.ngxService.stop();
            });
        },
        onUpdated: (key, values) => {
          this.ngxService.stop();
        },

      });

      this.ngxService.stop();
    });


    this.addNew = this.addNew.bind(this);
  }


  async initObject() {
    try {
      this.shareholderTypesArray = await this.assembleaService.getSHTypes();
      this.agencyArray = await this.assembleaService.LoadAgencies();
      this.vipStyleArray = await this.assembleaService.getVipNoteStyles();
      this.LegalRepresentatives = await this.assembleaService.getLegalRepresentatives();
      this.RepresentedShareholder = await this.assembleaService.getRepresentedShareholder();

    } catch (e) {

      let dialog = this.errorService.showErrorMessage(e);
      //await dialog.afterClosed().toPromise();

    }
  }

  private async loadLegalRepresentatives() {
    this.LegalRepresentatives = await this.assembleaService.getLegalRepresentatives();
  }

  /*visualizza header du più righe*/
  titleHeaderTemplate(header, info) {
    $("<div>").html(info.column.caption.replace(/\r\n/g, "<br/>")).appendTo(header);
  }

  /*Informazioni sui Rappresentanti Legali per ogni partecipante*/
  getLegalRepresentativesCount(PAID): any {
    try {
      return isNullOrUndefined(this.LegalRepresentatives[PAID]) ? '+' : this.LegalRepresentatives[PAID].length;
    } catch (e) { return null; }
  }

  getRepresentedShareholderCount(PAID): number {
    try {
      return isNullOrUndefined(this.RepresentedShareholder[PAID]) ? null : this.RepresentedShareholder[PAID].length;
    } catch (e) { return null; }
  }
  /* Fine Informazioni sui Rappresentanti Legali per ogni partecipante*/

  /* Gestione Partecipanti*/

  async addNew() {
    console.log("addNew");
    this.ngxService.start();

    let descr: string = await this.assembleaService.getNewShareholderName();
    let csid: string = await this.assembleaService.getNewShareholderID();

    let stid: number = this.GetDefaultSTID();

    // creazione di un utente con proprietà di base
    let shareholder: vShareholders = new vShareholders({
      AssociatedOn: null,
      BirthDate: null,
      CreatedOn: null,
      ModifiedOn: null,
      HasBeenAddedOnFly: true,
      HasCertification: false,
      Vip: null,
      NoS: 1,
      NoSB: 0,
      NoSC: 0,
      NoSD: 0,
      LRCOUNT: null,
      PAID: null,
      STID: stid,
      VoteCount: null,
      VipNoteType: null,
      Address: null,
      AgencyCode: null,
      BirthPlace: null,
      BusinessName: descr,
      CDG: null,
      CSID: csid,
      CheckInCounter: null,
      City: null,
      CustomField01: null,
      CustomField02: null,
      CustomField03: null,
      DelegationGroup: null,
      DelegationZone: null,
      Email: null,
      FiscalCode: null,
      Gender: null,
      PhoneNumber: null,
      ShareholderTypeDescription: null,
      StateProvince: null,
      VipNote: null,
      ZipCode: null,
    });

    await this.dataSource.insert(shareholder);

  }

  private GetDefaultSTID(): number {
    if (this.shareholderTypesArray == null) {
      return null;
    }

    if (this.shareholderTypesArray.length == 0) return 1;

    let firstSHType: ShareholderType = this.shareholderTypesArray.reduce(function (prev, current) {
      return (prev.STID < current.STID) ? prev : current
    })

    return firstSHType.STID;
  }

  async onRowUpdating(e) {
    console.log(e);
    e.newData = $.extend({}, e.oldData, e.newData);

  }

  /* Fine Gestione Partecipanti*/






  /* Gestione Popup Rappresentanti Legali e Categorie*/

  currentLegalRepresentatives: any[] = [];
  currentPAID: any = null;
  popupVisible = false;

  showToast = false;
  toastType = 'success';
  toastMessage = 'OK';

  currentOwnedCategories: any[] = [];
  currentPAIDCategorie: any = null;
  popupCategorieVisible = false;

  showToastCategorie = false;
  toastTypeCategorie = 'success';
  toastMessageCategorie = 'OK';

  TitoloLR ='Legali Rappresentanti'
  TitoloCategorie = 'Categorie'

  showLR(PAID, name) {
    this.currentPAID = PAID;
    if (!isNullOrUndefined(name)) {
      this.TitoloLR = `Legali Rappresentanti per '${name}'`
    }
    this.currentLegalRepresentatives = isNullOrUndefined(this.LegalRepresentatives) || isNullOrUndefined(this.LegalRepresentatives[PAID]) ? [] : this.LegalRepresentatives[PAID];
    this.popupVisible = true;
    this.popupCategorieVisible = false;
  }

  async showCategorie(PAID, name) {
    this.currentPAIDCategorie = PAID;
    if (!isNullOrUndefined(name)) {
      this.TitoloCategorie = `Categorie per '${name}'`
    }
    this.currentOwnedCategories = await this.assembleaService.LoadShareholderCategories(PAID);

    this.popupVisible = false;
    this.popupCategorieVisible = true;
  }

  private dataGrid: any;

  saveGridInstance(e) {
    this.dataGrid = e.component;
  }

  async closeLRPopupClick() {
    
    this.popupVisible = false;
  }

  async closeCategoryClick() {
    this.dataGrid.refresh();
    this.popupCategorieVisible = false;
  }



  async CategoryUpdating(e) {
    try {
      this.ngxService.start();
      await this.assembleaService.ChangeOwnedCategories(e.key, this.currentPAIDCategorie, e.newData.Owned);
      this.currentOwnedCategories = await this.assembleaService.LoadShareholderCategories(this.currentPAIDCategorie);
      console.log({ 'currentOwnedCategories reloaded': e });
    } finally { this.ngxService.stop(); }
  }

  LREditingStart(e) {

    if (!isNullOrUndefined(e.data.CSID)) {
      e.cancel = true;
      this.toastType = 'warning';
      this.toastMessage = 'Impossible modificare questa rappresentanza';
      this.showToast = true;
    } else {
      e.component.columnOption("CSID", "allowEditing", false);
    }
  }

  LRInitNewRow(event, data) {
    event.component.columnOption("CSID", "allowEditing", true);
    event.data.PAID = this.currentPAID;

    event.data.LRSortN = 0;

    if (data.length > 0) {

      let lastDetail = data.reduce(function (prev, current) {
        return (prev.LRSortN > current.LRSortN) ? prev : current
      });
      if (!isNullOrUndefined(lastDetail) && !isNullOrUndefined(lastDetail.LRSortN))
        event.data.LRSortN = lastDetail.LRSortN + 1;
    }

  }

  /* gestisce il salvataggio di una nuova rappresentanza*/
  LRInserted(event) {

    this.ngxService.start();
    event.component.beginUpdate();
    if (isNullOrUndefined(event.data.CSID) || isNullOrWhiteSpace(event.data.CSID)) {
      event.data.PAID = this.currentPAID;
      event.data.LRPAID = null;
      //event.data.BusinessName = null; //popolato da gui
      event.data.Address = null;
      event.data.City = null;
      event.data.StateProvince = null;
      event.data.ZipCode = null;
      event.data.FiscalCode = null;
      event.data.Gender = null;
      event.data.BirthDate = null;
      event.data.BirthPlace = null;
      event.data.HasBeenAddedOnFly = false;
      //event.data.Email = null; //popolato da gui
      //event.data.PhoneNumber = null; //popolato da gui

      this.assembleaService.insertOrUpdatevLegalRepresent(event.data).then(() => {
        this.toastType = 'success';
        this.toastMessage = 'Rappresentanza inserita';
        this.showToast = true;
      }).catch(async (e) => {
        this.errorService.showErrorMessage(e);
        this.ngxService.stop();
      }).finally(async () => {
        await this.loadLegalRepresentatives();
        this.showLR(this.currentPAID, null);

      });

    }
    else {
      this.assembleaService.findPotentialAttendantByCSID(event.data.CSID).then(async (value) => {
        console.log(value);
        if (isNullOrUndefined(value)) {
          //non trovato
          this.errorService.showWarningMessage(`Attenzione: Il Partecipante ${event.data.CSID} non esiste nell'anagrafica dei partecipanti`, '')

          this.ngxService.stop();

        }
        else {

          event.data.PAID = this.currentPAID;
          event.data.LRPAID = value.PAID;
          event.data.BusinessName = value.BusinessName;
          event.data.Address = value.Address;
          event.data.City = value.City;
          event.data.StateProvince = value.StateProvince;
          event.data.ZipCode = value.ZipCode;
          event.data.FiscalCode = value.FiscalCode;
          event.data.Gender = value.Gender;
          event.data.BirthDate = value.BirthDate;
          event.data.BirthPlace = value.BirthPlace;
          event.data.HasBeenAddedOnFly = value.HasBeenAddedOnFly;
          event.data.Email = value.Email;
          event.data.PhoneNumber = value.PhoneNumber;

          this.assembleaService.checkAndAddLegalRelationship(value.PAID, this.currentPAID).then(async () => {
            await this.loadLegalRepresentatives();
            this.showLR(this.currentPAID, null);
            this.toastType = 'success';
            this.toastMessage = 'Rappresentante Legale inserito';
            this.showToast = true;
          }).catch(async (e) => {
            this.errorService.showErrorMessage(e, "Errore nell'inserimento della rappresentanza legale");
            this.ngxService.stop();
          }).finally(async () => {
            await this.loadLegalRepresentatives();
            this.showLR(this.currentPAID, null);

          });

        }
      }).catch(async (e) => {

        this.errorService.showErrorMessage(e, "Errore nella ricerca del rappresentante legale");
        this.ngxService.stop();
      }).finally(async () => {
        await this.loadLegalRepresentatives();
        this.showLR(this.currentPAID, null);

      });

    }
    event.component.refresh();
    event.component.endUpdate();
    this.ngxService.stop();
  }

  /* gestisce la modifica di una rappresentanza */
  async LRUpdated(event) {
    console.log(event);
    this.assembleaService.insertOrUpdatevLegalRepresent(event.data).then(() => {
      this.toastType = 'success';
      this.toastMessage = 'Rappresentante Legale modificato';
      this.showToast = true;
    }).catch(async (e) => {
      this.errorService.showErrorMessage(e, "Errore nella modifica della rappresentanza legale");
      this.ngxService.stop();
    }).finally(async () => {
      await this.loadLegalRepresentatives();
      this.showLR(this.currentPAID, null);

    });
  }

  /* elimina una rappresentanza */
  async LRRemoved(event) {

    if (!isNullOrUndefined(event.data.LRPAID) && !isNullOrUndefined(event.data.PAID)) {
      this.ngxService.start();
      event.component.beginUpdate();
      this.assembleaService.deletevLegalRepresent(event.data).then(() => {
        this.toastType = 'success';
        this.toastMessage = 'Rappresentanza eliminata';
        this.showToast = true;
      }).catch(async (e) => {
        this.errorService.showErrorMessage(e, "Errore nell'eliminazione della rappresentanza legale");
        this.ngxService.stop();
      }).finally(async () => {

        await this.loadLegalRepresentatives();
        this.showLR(this.currentPAID, null);
        event.component.refresh();
        event.component.endUpdate();
        this.ngxService.stop();
      });
    }
  }


  nameOrCSIDValidation(params) {

    if ((isNullOrUndefined(params.data.BusinessName) || isNullOrWhiteSpace(params.data.BusinessName))
      && (isNullOrUndefined(params.data.CSID) || isNullOrWhiteSpace(params.data.CSID)))
      return false;
    return true;

  }
  /* Fine Gestione Popup Rappresentanti Legali*/

}



//@NgModule({
//    declarations: [
//        ShareholderConfigComponent
//    ],
//    imports: [
//        BrowserModule,
//        ApplicationPipesModule,
//        CommonModule,
//        DxToolbarModule,
//        DxDataGridModule,
//        DxPopupModule,
//        DxButtonModule,
//        DxToastModule
//    ],
//    exports: [],
//    providers: [AuthService, ScreenService, ConfigurationService, StorageService, IdentityService, SignalrService, ToastrService, NotificationService,
//        //{ provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
//        /*{ provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true }*/ 
//    ],
//    bootstrap: []
//})

//export class ShareholderConfigModule {

//}
